import axiosInstance from '../../../lib/axios';

class SettingsService {
  async getSettings() {
    try {
      const response = await axiosInstance.get('/api/v1/admin/settings');
      console.log('Settings service response:', response.data);
      return response.data;
    } catch (error) {
      console.error('Settings API error:', error);
      // Retourner un tableau vide en cas d'erreur (comme si aucun paramètre n'existe)
      if (error.response?.status === 404) {
        return [];
      }
      throw error;
    }
  }

  async getSetting(key) {
    const response = await axiosInstance.get(`/api/v1/admin/settings/${key}`);
    return response.data;
  }

  async createSetting(data) {
    const response = await axiosInstance.post('/api/v1/admin/settings', data);
    return response.data;
  }

  async updateSetting(key, value) {
    const response = await axiosInstance.put(`/api/v1/admin/settings/${key}`, { value });
    return response.data;
  }

  async deleteSetting(key) {
    const response = await axiosInstance.delete(`/api/v1/admin/settings/${key}`);
    return response.data;
  }
}

export const settingsService = new SettingsService();
